module.exports = __webpack_public_path__ + "static/media/Calendar.6f4c7619.svg";